import React from "react";
import { ClickAwayListener, MenuItem, Popper } from "@material-ui/core";
import useStyles from "../../themes/style.js";
import EditIcon from "@material-ui/icons/Edit";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { AiFillFilePdf } from "react-icons/ai";
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { MdOutlineQueryStats } from "react-icons/md";
import Tooltip from "@material-ui/core/Tooltip";
import ViewIcon from "@material-ui/icons/Visibility";
import { useHistory } from "react-router-dom";

const UserActions = (props) => {
    const classes = useStyles();
    const history = useHistory()
    const handleClick = (e) => {
        e.stopPropagation();
        props.handleMenuClick(props.index, e);
    };

    const handleEditClick = () => {
        props.handleMenuClick(props.index, null);
        props.setState({ ...props.state, right: true });
        props.editreset();
        props.setDataList("EDIT");
        props.setUserEdit({
            ...props.userEdit,
            id: props.item.user.id,
            email: props.item.user.email,
            firstName: props.item.firstName,
            lastName: props.item.lastName,
            mobile: props.item.mobile,
            roleName: props.item.user.roleName,
            companyName: props.item.companyName,
            employeeId: props.item.employeeId,
            companyAddress: props.item.companyAddress,
            headOfficeLocation: props.item.headOfficeLocation,
            branchOfficeLocation: props.item.branchOfficeLocation,
            capabilities: props.item.capabilities,
            recruiterCapacity: props.item.recruiterCapacity,
            totalExp: props.item.totalExp,
            currentLocation: props.item.currentLocation,
            willingToWork: props.item.willingToWork,
            hoursToWork: props.item.hoursToWork,

            minimumCommercialFee: props.item.minimumCommercialFee,
            minimumMarkup: props.item.minimumMarkup,
            sourceProfileFrom: props.item.sourceProfileFrom,
            contractStaffing: props.item.contractStaffing,
            aboutATS: props.item.aboutATS,
            GSTNumber: props.item.GSTNumber,
        });

        const sourceParts = props.item.sourceProfileFrom?.split(',').map(part => part.trim()) || [];

        const standardOptions = ["Job Portal", "Social Media", "Reference"];
        const otherMentions = sourceParts.filter(part => !standardOptions.includes(part) && part !== "");

        props.setEditVendorDetails(prevDetails => ({
            ...prevDetails,
            JobPortal: sourceParts.includes("Job Portal"),
            SocialMedia: sourceParts.includes("Social Media"),
            Reference: sourceParts.includes("Reference"),
            OthersMention: otherMentions.length > 0,
            OthersMentionValue:  otherMentions.join(', '),
        }));
    }


    const handleAssignRequirements = () => {
        const userRoleName = props.item.user?.roleName;
        const freelancerName = props.item.firstName + " " + props.item.lastName;
        if (userRoleName === "SUBVENDOR") {
            history.push(`/app/freelancer/requirements?user_id=${props.item.id}&user_name=${freelancerName}`)
        }
        if (userRoleName === "SUBCONTRACT") {
            history.push(`/app/vendor/requirements?user_id=${props.item.id}&user_name=${freelancerName}`)
        }
    }

    const handleRecCoinReport = () => {
        const userRoleName = props.item.user?.roleName;
        const freelancerName = props.item.firstName + " " + props.item.lastName;
        if (userRoleName === "SUBVENDOR") {
            history.push(`/app/freelancer/reports?user_id=${props.item.id}&user_name=${freelancerName}`)
        }
        if (userRoleName === "SUBCONTRACT") {
            history.push(`/app/vendor/reports?user_id=${props.item.id}&user_name=${freelancerName}`)
        }
    }

    return (
        <>
            <MoreVertIcon
                key={props.index}
                onClick={handleClick}
                style={{ cursor: "pointer" }}
            />
            <div >
                <Popper open={props.index === props.activeIndex} anchorEl={props.anchorEl}
                    modifiers={{
                        offset: {
                            enabled: true,
                            offset: "40px, 0",
                        },
                        flip: {
                            enabled: true,
                        },
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: 'window', // This keeps the popper within the window boundaries
                        },
                        arrow: {
                            enabled: true,
                        },
                    }}
                >
                    <ClickAwayListener
                        onClickAway={(e) => {
                            props.handleMenuClick(props.index, null);
                        }}
                    >
                        <div className={classes.userActionDrop}>
                            <MenuItem
                                onClick={(e) => {
                                    handleEditClick()

                                }}
                            >
                                <Tooltip
                                    title="Edit User"
                                    placement="right"
                                    aria-label="edit"
                                >
                                    <EditIcon className={classes.toolIcon} />
                                </Tooltip>
                            </MenuItem>

                            <MenuItem
                                onClick={(e) => {
                                    props.handleMenuClick(props.index, null);
                                    props.setState({ ...props.state, right: true });
                                    props.editreset();
                                    props.setDataList("VIEW");
                                    props.setUserEdit({
                                        ...props.userEdit,
                                        id: props.item.user.id,
                                        email: props.item.user.email,
                                        firstName: props.item.firstName,
                                        lastName: props.item.lastName,
                                        mobile: props.item.mobile,
                                        roleName: props.item.user.roleName,
                                        employeeId: props.item.employeeId,
                                        companyName: props.item.companyName,
                                        companyAddress: props.item.companyAddress,
                                        headOfficeLocation: props.item.headOfficeLocation,
                                        branchOfficeLocation: props.item.branchOfficeLocation,
                                        capabilities: props.item.capabilities,
                                        recruiterCapacity: props.item.recruiterCapacity,
                                        totalExp: props.item.totalExp,
                                        currentLocation: props.item.currentLocation,
                                        willingToWork: props.item.willingToWork,
                                        hoursToWork: props.item.hoursToWork,

                                        minimumCommercialFee: props.item.minimumCommercialFee,
                                        minimumMarkup: props.item.minimumMarkup,
                                        sourceProfileFrom: props.item.sourceProfileFrom,
                                        contractStaffing: props.item.contractStaffing,
                                        aboutATS: props.item.aboutATS,
                                        GSTNumber: props.item.GSTNumber,
                                    });
                                }}
                            >
                                <Tooltip
                                    title="View User"
                                    placement="right"
                                    aria-label="view"
                                >
                                    <ViewIcon className={classes.toolIcon} />
                                </Tooltip>
                            </MenuItem>

                            {(props.item.user?.roleName === "SUBVENDOR" || props.item.user?.roleName === "FREELANCER" || props.item.user?.roleName === "SUBCONTRACT") && <>
                                <MenuItem
                                    onClick={handleAssignRequirements}
                                >
                                    <Tooltip
                                        title="Assign Requirements"
                                        placement="right"
                                        aria-label="requirements"
                                    >
                                        <AssignmentIndIcon className={classes.toolIcon} />
                                    </Tooltip>
                                </MenuItem>

                                {/* <MenuItem
                                    onClick={handleRecCoinReport}
                                >
                                    <Tooltip
                                        title="RecCoin Report"
                                        placement="right"
                                        aria-label="report"
                                    >
                                        <div style={{ width: "25px", height: "25px", }}>
                                            <MdOutlineQueryStats className={classes.toolIcon} />
                                        </div>
                                    </Tooltip>
                                </MenuItem> */}

                                <MenuItem
                                    onClick={(e) => {
                                        props.handleMenuClick(props.index, null);
                                        props.handleNDAOpen(props.item)
                                    }}
                                >
                                    <Tooltip
                                        title="NDA File"
                                        placement="right"
                                        aria-label="NDA"
                                    >
                                        <div style={{ width: "25px", height: "25px", }}>
                                            <AiFillFilePdf className={classes.toolIconDelete} />
                                        </div>
                                    </Tooltip>
                                </MenuItem>
                            </>
                            }
                        </div>
                    </ClickAwayListener>
                </Popper>
            </div>
        </>
    );
};

export default UserActions;
